var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'c-progress',
    { 'c-progress--zero': _vm.now <= 0, 'c-progress--large': _vm.large },
  ]},[_c('div',{staticClass:"c-progress__bar",style:({ width: _vm.percent })}),_c('span',{staticClass:"c-progress__value",style:({ width: _vm.now > 0 ? _vm.percent : '100%' })},[_vm._v(_vm._s(_vm.showValue ? _vm.percent.substr(0, _vm.percent.length - 1) : null))])])
}
var staticRenderFns = []

export { render, staticRenderFns }